import { UserCoverageSummary } from '@ampsec/platform-client';
import { Typography } from 'Components/atoms';

interface EndpointCountCellRendererProps {
  data: UserCoverageSummary;
}

const EndpointCountCellRenderer = ({ data: row }: EndpointCountCellRendererProps) => (
  <div className="d-flex align-items-center w-100 h-100">
    <Typography variant="body2">{row.assets?.length ?? 0}</Typography>
  </div>
);

export default EndpointCountCellRenderer;
